import { useCallback, useContext } from 'react';

import { defineMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { emptyObject } from 'ui-components/default-props/empty';

import ReuseableGridButton from '../../../components/grid-header/reusable-grid-button';
import { useSalesOrderForFulfillmentId } from '../../../hooks/entities/selectors/fulfillments';
import { NewReturnFulfillmentId } from '../../../orders/order-details/hooks/use-pending-return';
import { useReturnNavigation } from '../../../orders/order-details/hooks/use-return-navigation';
import { useCanCreateEnhancedReturn } from '../../../store/returns/returns.helpers';
import { useTrackWorkflow, WorkflowSteps } from '../../../tracking/use-workflow-tracking';
import { EventSourceStrings, Workflows } from '../../../tracking/tracking-constants';
import Global from '../../../store/global-selectors';
import { FulfillmentContext } from '../context';

const message = defineMessage({
  description: 'Fulfillments Grid Create Return Button text',
  defaultMessage: 'Create Return',
  id: '74EZLo',
});

export const CreateReturnButton = () => {
  const { selectedFulfillmentIds } = useContext(FulfillmentContext);
  const amountSelected = selectedFulfillmentIds.length;
  const disabled = amountSelected !== 1;
  const fulfillments = useSelector((state) =>
    Global.selectEntitiesFulfillmentsByIds(state, {
      fulfillmentIds: selectedFulfillmentIds,
    }),
  );
  const fulfillmentId = fulfillments[0]?.fulfillmentId;
  const { salesOrderId } = useSalesOrderForFulfillmentId(fulfillmentId) ?? emptyObject;
  const shouldUseEnhancedReturn = useCanCreateEnhancedReturn(salesOrderId);

  const { navigateToReturn } = useReturnNavigation();
  const trackCreateReturn = useTrackWorkflow(Workflows.CREATE_RETURN_FLOW);

  const onClick = useCallback(() => {
    trackCreateReturn(WorkflowSteps.START, {
      enhanced: shouldUseEnhancedReturn,
      fulfillmentPlanId: fulfillmentId,
      salesOrderId,
      source: EventSourceStrings.SHIPMENTS_GRID_HEADER,
    });
    navigateToReturn(salesOrderId, NewReturnFulfillmentId, shouldUseEnhancedReturn);
  }, [fulfillmentId, navigateToReturn, salesOrderId, shouldUseEnhancedReturn, trackCreateReturn]);

  return <ReuseableGridButton actionHandler={onClick} disable={disabled} messageDescriptor={message} theme='tertiary' />;
};
